jQuery(document).ready(function($) {

    $('.view-teaser-blokken .views-row').not('.page-node-12 .view-teaser-blokken .views-row').each(function(index){
        if($(this).find('a').length == 1){
            $(this).addClass('clickable').click(function(event) {
                window.location = $(this).find('a').attr('href'); 
            });
        }
    });

    $('.page-node-type-homepagina main .view-nieuws-overzicht .view-content').slick({
        autoplay: false,
        infinite: true,
        arrows: true,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    dots: false,
                }
            }
        ]
    });

    var options = {
        afterReveal: function (el) {
            el.classList.add('revealed');
        },
        afterReset: function (el) {
            el.classList.remove('revealed');
        }
    };
    window.sr = ScrollReveal(options);
    sr.reveal('.page-node-type-homepagina main h2, ' +
        '.page-node-type-homepagina main .btn-default, ' +
        '.page-node-type-homepagina main .btn-primary,' +
        '.page-node-type-homepage-alt main h2' +
        '.page-node-type-homepage-alt main .btn-default' +
        '.page-node-type-homepage-alt main .btn-primary', {
        scale: 1,
        distance: '10px',
        origin: 'top',
        // delay: 250,
    });
    sr.reveal('.page-node-type-homepagina #highlighted .view-home-header .views-row .section-left, ' +
        '.page-node-type-homepage-alt #highlighted .view-home-header .views-row .section-left', {
        delay: 200,
        scale: 1,
        distance: '10px',
        origin: 'top',
    });
    sr.reveal('.page-node-type-homepagina #highlighted .view-home-header .views-row .section-right ul li,' +
        '.page-node-type-homepage-alt #highlighted .view-home-header .views-row .section-right ul li', {
        delay: 500,
        scale: 1,
        distance: '10px',
        origin: 'top',
    }, 50);
    sr.reveal('.page-node-type-homepagina main #block-primaireinhoudvandepagina section#contentblock-news .view-nieuws-overzicht .view-content,' +
        '.page-node-type-homepage-alt main #block-primaireinhoudvandepagina section#contentblock-news .view-nieuws-overzicht .view-content', {
        distance: '100%',
        origin: 'right',
    });
    sr.reveal('.page-node-type-homepagina main #block-primaireinhoudvandepagina section#contentblock-news .view-nieuws-overzicht .view-content .views-row,' +
        '.page-node-type-homepage-alt main #block-primaireinhoudvandepagina section#contentblock-news .view-nieuws-overzicht .view-content .views-row', {
        origin: 'right',
        distance: '100%',
        duration: 750,
        delay: 0,
        // viewFactor:0.3,
        mobile: false,
        scale: 1,
    }, 50);

    $('a.youtube-popup').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });

    $('.page-node-type-homepagina main #block-primaireinhoudvandepagina section#contentblock-2 .field--name-field-image .image-link').magnificPopup({
        closeOnContentClick: true,
        mainClass: 'mfp-with-zoom',
        zoom: {
            enabled: true, // By default it's false, so don't forget to enable it

            duration: 300, // duration of the effect, in milliseconds
            easing: 'ease-in-out', // CSS transition easing function

            // The "opener" function should return the element from which popup will be zoomed in
            // and to which popup will be scaled down
            // By defailt it looks for an image tag:
            opener: function(openerElement) {
              // openerElement is the element on which popup was initialized, in this case its <a> tag
              // you don't need to add "opener" option if this code matches your needs, it's defailt one.
              return openerElement.is('img') ? openerElement : openerElement.find('img');
            }
          },
        image: {
            verticalFit: true
        }
    });

    $("a.scrollto").on('click',function(){
        var targetDiv = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(targetDiv).offset().top
        }, 500);
        return false;
    });

    $('.view-nieuws-overzicht .slick-slide').click(function(event){
        var currentActiveIndex = $('.slick-track .slick-slide.slick-current').data('slick-index');
        // console.log('huidige active index', currentActiveIndex);
        if($(this).data('slick-index') == currentActiveIndex + 3){
            event.stopImmediatePropagation();
            event.preventDefault();
            // console.log('volgende slide!');
            $('.page-node-type-homepagina main .view-nieuws-overzicht .view-content').slick('slickNext');
            $(this).addClass('active');
        }
    });

    if ($(window).width() < 1450) {
        $("h1, h2, .view-nieuws-overzicht .view-content .views-row a span.title").hyphenate('nl');        
    }
});